import { createAction } from 'redux-actions';

import * as C from './constants';

export const submitFormRequest = createAction(C.SUBMIT_FORM_REQUEST);
export const submitFormSuccess = createAction(C.SUBMIT_FORM_SUCCESS);

export const getAssistanceListRequest = createAction(C.GET_ASSISTANCE_LIST_REQUEST);
export const getAssistanceListSuccess = createAction(C.GET_ASSISTANCE_LIST_SUCCESS);
